import { render, staticRenderFns } from "./Baidu.vue?vue&type=template&id=4fa6c776"
import script from "./Baidu.vue?vue&type=script&lang=js"
export * from "./Baidu.vue?vue&type=script&lang=js"
import style0 from "./Baidu.vue?vue&type=style&index=0&id=4fa6c776&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports